import Forecasts from './Forecasts';

export default Forecasts;
